<template>
  <b-container class="bv-example-row">
    <b-row
      v-for="({ category, companies, id }, index) in filteredShortlisted"
      :key="id"
      class="mt-2"
    >
      <b-col class="shortlisted-categories-main-cont" cols="12">
        <div class="mt-1">
          <p class="mb-1 shortlisted-categories-name-text">{{ category }}</p>
        </div>
        <div
          class="shortlisted-categories-icon-cont mt-1"
          v-b-toggle="`accordion-${id}`"
          @click="showIcon(index)"
        >
          <i
            v-if="shortlisted[index].show"
            class="fa fa-minus shortlisted-categories-icon"
          />
          <i v-else class="fa fa-plus shortlisted-categories-icon" />
        </div>
      </b-col>
      <b-collapse
        class="shortlisted-categories-collapse-main-cont"
        :id="`accordion-${id}`"
      >
        <div class="shortlisted-categories-collapse-cont">
          <div :key="id" v-for="{ id, logo, candidate_details } in companies" class="shortlisted-company-item">
            <template v-if="candidate_details">
              <img
              class="shortlisted-memb-logo"
              :src="candidate_details.prof_pic"
              @click="goToPersonalWall(candidate_details.customer_id)"
            />
            <b @click="goToPersonalWall(candidate_details.customer_id)" class='candidate-name'>{{ candidate_details.name }}</b>
            <span @click="goToPersonalWall(candidate_details.customer_id)" class='candidate-job'>{{ candidate_details.job_title }}</span>
            <a
            class="profile-link"
            @click="goToCompanyProfile(id)"
          >{{ candidate_details.company }}</a>
            </template>
            <template v-else>
              <img
              class="shortlisted-comp-logo"
              :src="logo"
              @click="goToCompanyProfile(id)"
              />
            </template>
          </div>
        </div>
      </b-collapse>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions } from 'vuex';
import getIDfromURL from '../../../utils/getIDfromURL';

export default {
	computed: {
		filteredShortlisted() {
			return this.shortlisted.filter((el) => el.companies.length);
		},
	},
  data() {
    return {
      shortlisted: [],
      categories: [],
      registrationData: [],

    };
  },
  async mounted() {
    if (this.$route.params.awardId) {
      this.registrationData = await this.fetchRegistrationList(this.$route.params.awardId);
      if (this.registrationData.length && new Date(this.registrationData[0].short_listed_publication) > Date.now()) {
        this.$router.push({ name: 'AwardInfo', awardId: this.$route.params.awardId, slug: this.$route.params.slug });
      }
      this.categories = await this.fetchCategories(this.$route.params.awardId);
    }
    if (this.categories.length) {
      this.categories.forEach(async (el) => {
        const results = await this.fetchShortlisted(el.id);

        const companies = [];
        if (results.length) {
          results.forEach(async (elem) => {
            companies.push({
              id: getIDfromURL(elem.company),
              logo: elem.company_details.logo,
              candidate_details: elem.candidate_details,
            });
          });
        }

        this.shortlisted.push({
          companies,
          category: el.name,
          id: el.id,
        });
      });
    }
  },
  methods: {
    ...mapActions({
      fetchShortlisted: 'awards/fetchShortlisted',
      fetchRegistrationList: 'awards/fetchRegistrationList',
      fetchCategories: 'awards/fetchCategories',
    }),
    showIcon(index) {
      const shortlisted = this.$lodash.cloneDeep(this.shortlisted);
      shortlisted[index].show = !shortlisted[index].show;
      this.shortlisted = shortlisted;
    },
    goToCompanyProfile(id) {
      if (id) {
        const companyId = `${id}`;
        this.$router.push({ name: 'companyProfile', params: { companyId } });
      }
    },
    goToPersonalWall(customerId) {
      this.$router.push({ name: 'MemberWall', params: { customerId } });
    },
  },
};
</script>

<style scoped>
.shortlisted-categories-name-text {
  color: #bd9d5f;
  white-space: pre-wrap;
  max-width: 450px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.shortlisted-categories-collapse-main-cont {
  width: 100%;
}
.shortlisted-categories-collapse-cont {
  margin-top: 1px;
  background-color: #ffffff;
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}
.shortlisted-categories-main-cont {
  background-color: white;
  display: flex;
}
.shortlisted-categories-icon-cont {
  margin-left: auto;
}
.shortlisted-categories-icon {
  color: white;
  background-color: #bd9d5f;
  padding: 5px;
  font-size: 10px;
  cursor: pointer;
}
.shortlisted-comp-logo {
  width: 92px;
  height: 92px;
  object-fit: contain;
  margin: 10px;
  border: 1px solid #bd9d5f;
}
.shortlisted-comp-logo:hover{
  cursor: pointer;
}
.shortlisted-memb-logo {
  width: 92px;
  height: 92px;
  object-fit: contain;
  margin: 10px;
  border: 1px solid #bd9d5f;
  border-radius: 0 8px 8px 8px;
}
.text-center {
  text-align: center;
}
.shortlisted-company-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
}
.profile-link {
  color: #bd9d5f !important;
  font-size: 12px;
  text-decoration: none;
  cursor: pointer;
}
.candidate-name {
  font-size: 14px;
  font-weight: 600;
  margin: 0;
  cursor: pointer;
}
.candidate-job {
  font-size: 12px;
  color: #707070;
  margin: 0;
  cursor: pointer;
}
</style>
